import '@fontsource-variable/geist';
import '@fontsource-variable/jetbrains-mono';
import './styles/tokens.css';
import './styles/controls.css';
import './styles/shell.css';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { lang, t } from './i18n/index.js';
import { Centered } from './layout.js';
import { SetupStore } from './store.js';
import { applyTheme, loadTheme } from './theme.js';

applyTheme(loadTheme());
document.documentElement.lang = lang;
document.title = t('app.title');

const root = createRoot(document.getElementById('app') as HTMLElement);
// The relay: on Cloudflare Pages the page lives apart from it (setup.tellvo.app → use.tellvo.app,
// tellvo-voip-client#97), so the build names it; otherwise it is this host's /ws (dev, compose).
const relayURL = import.meta.env.VITE_RELAY_URL || `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;

// The phone's landing path. A desktop browser that opens the link has nothing to do here.
if (location.pathname.startsWith('/p/')) {
  root.render(<Centered><div className="card stop"><p>{t('landing.text')}</p></div></Centered>);
} else if (import.meta.env.DEV && new URLSearchParams(location.search).has('preview')) {
  // Screens on sample data, without a phone or a relay (dev server only).
  const { previewStore } = await import('./preview.js');
  root.render(<App store={previewStore(new URLSearchParams(location.search))} />);
} else {
  const store = new SetupStore(relayURL, location.origin);
  window.addEventListener('beforeunload', (event) => {
    if ((store.view?.pending ?? 0) > 0 && !store.online) event.preventDefault();
    store.bye();
  });
  store.start();
  root.render(<App store={store} />);
}
